export default "__VITE_PUBLIC_ASSET__891cb462__"